import { render, staticRenderFns } from "./WorkHistory.vue?vue&type=template&id=6d010166&"
import script from "./WorkHistory.vue?vue&type=script&lang=js&"
export * from "./WorkHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports